const emailCampaignActions = {
  // SAGA
  GET_EMAIL_CAMPAIGNS: 'GET_EMAIL_CAMPAIGNS',
  GET_EMAIL_CAMPAIGN: 'GET_EMAIL_CAMPAIGN',
  GET_EMAIL_CAMPAIGN_SUMMARY: 'GET_EMAIL_CAMPAIGN_SUMMARY',
  GET_EMAIL_CAMPAIGN_COMPANIES: 'GET_EMAIL_CAMPAIGN_COMPANIES',
  CREATE_OR_UPDATE_EMAIL_CAMPAIGN_WATCHER: 'CREATE_OR_UPDATE_EMAIL_CAMPAIGN_WATCHER',
  DELETE_EMAIL_CAMPAIGN_WATCHER: 'DELETE_EMAIL_CAMPAIGN_WATCHER',
  REFRESH_EMAIL_CAMPAIGN_STATS_WATCHER: 'REFRESH_EMAIL_CAMPAIGN_STATS_WATCHER',

  // REDUCER
  SET_EMAIL_CAMPAIGNS: 'SET_EMAIL_CAMPAIGNS',
  SET_EMAIL_CAMPAIGN: 'SET_EMAIL_CAMPAIGN',
  SET_EMAIL_CAMPAIGN_SUMMARY: 'SET_EMAIL_CAMPAIGN_SUMMARY',
  SET_EMAIL_CAMPAIGN_COMPANIES: 'SET_EMAIL_CAMPAIGN_COMPANIES',
  REFRESH_EMAIL_CAMPAIGN_STATS: 'REFRESH_EMAIL_CAMPAIGN_STATS',

  CREATE_EMAIL_CAMPAIGN: 'CREATE_EMAIL_CAMPAIGN',
  UPDATE_EMAIL_CAMPAIGN: 'UPDATE_EMAIL_CAMPAIGN',
  DELETE_EMAIL_CAMPAIGN: 'DELETE_EMAIL_CAMPAIGN',

  // ERROR
  EMAIL_CAMPAIGN_ERROR: 'EMAIL_CAMPAIGN_ERROR',
  RESET_EMAIL_CAMPAIGN_STATUS: 'RESET_EMAIL_CAMPAIGN_STATUS',

  // Saga functions
  getEmailCampaigns: (query) => ({
    type: emailCampaignActions.GET_EMAIL_CAMPAIGNS,
    payload: query,
  }),

  getEmailCampaign: campaignId => ({
    type: emailCampaignActions.GET_EMAIL_CAMPAIGN,
    payload: campaignId,
  }),

  getEmailCampaignSummary: campaignId => ({
    type: emailCampaignActions.GET_EMAIL_CAMPAIGN_SUMMARY,
    payload: campaignId,
  }),

  getEmailCampaignCompanies: (campaignId, getAll = false) => ({
    type: emailCampaignActions.GET_EMAIL_CAMPAIGN_COMPANIES,
    payload: { campaignId, getAll },
  }),

  createOrUpdateEmailCampaignWatcher: campaign => {
    return {
      type: emailCampaignActions.CREATE_OR_UPDATE_EMAIL_CAMPAIGN_WATCHER,
      payload: campaign,
    };
  },

  deleteEmailCampaignWatcher: campaign => {
    return {
      type: emailCampaignActions.DELETE_EMAIL_CAMPAIGN_WATCHER,
      payload: campaign,
    };
  },

  refreshEmailCampaignStatsWatcher: campaignId => ({
    type: emailCampaignActions.REFRESH_EMAIL_CAMPAIGN_STATS_WATCHER,
    payload: campaignId,
  }),

  // Reducer functions
  setEmailCampaigns: campaigns => ({
    type: emailCampaignActions.SET_EMAIL_CAMPAIGNS,
    payload: campaigns,
  }),

  setEmailCampaign: campaign => ({
    type: emailCampaignActions.SET_EMAIL_CAMPAIGN,
    payload: campaign,
  }),

  setEmailCampaignSummary: summary => ({
    type: emailCampaignActions.SET_EMAIL_CAMPAIGN_SUMMARY,
    payload: summary,
  }),

  setEmailCampaignCompanies: data => ({
    type: emailCampaignActions.SET_EMAIL_CAMPAIGN_COMPANIES,
    payload: data,
  }),

  createEmailCampaign: campaign => {
    return {
      type: emailCampaignActions.CREATE_EMAIL_CAMPAIGN,
      payload: campaign,
    };
  },

  updateEmailCampaign: campaign => {
    return {
      type: emailCampaignActions.UPDATE_EMAIL_CAMPAIGN,
      payload: campaign,
    };
  },

  deleteEmailCampaign: campaign => {
    return {
      type: emailCampaignActions.DELETE_EMAIL_CAMPAIGN,
      payload: campaign,
    };
  },

  resetEmailCampaignStatus: () => {
    return {
      type: emailCampaignActions.RESET_EMAIL_CAMPAIGN_STATUS,
    };
  },

  refreshEmailCampaignStats: campaign => ({
    type: emailCampaignActions.REFRESH_EMAIL_CAMPAIGN_STATS,
    payload: campaign,
  }),
};

export default emailCampaignActions;
